<template>
  <div>
    <b-card no-header>
      <b-form>
        <b-form-group
          label="Banco"
          label-for="banco"
          :label-cols="labelCols"
          horizontal>
          <b-form-input 
            id="banco" 
            :value="banco" 
            type="text"
            readonly>
          </b-form-input>
        </b-form-group>

        <b-form-group
          label="Tarjeta"
          label-for="tarjetaMarca"
          :label-cols="labelCols"
          horizontal>
          <b-form-input 
            id="tarjetaMarca" 
            :value="tarjetaMarca"
            type="text"
            readonly>
          </b-form-input>
        </b-form-group>

        <b-form-group
          label="Nro.Cuenta"
          label-for="numeroCuenta"
          :label-cols="labelCols"
          horizontal>
          <b-form-input 
            id="numeroCuenta" 
            :value="numeroCuenta" 
            type="text"
            readonly>
          </b-form-input>
        </b-form-group>

        <b-form-group
          label="Cierre"
          label-for="fechaCierre"
          :label-cols="labelCols"
          horizontal>
          <b-form-input 
            id="fechaCierre" 
            :value="fechaCierre | fecha" 
            type="text"
            readonly>
          </b-form-input>
        </b-form-group>

        <b-form-group
          label="Vencimiento"
          label-for="fechaVencimiento"
          :label-cols="labelCols"
          horizontal>
          <b-form-input 
            id="fechaVencimiento" 
            :value="fechaVencimiento | fecha" 
            type="text"
            readonly>
          </b-form-input>
        </b-form-group>

        <hr>

        <b-row>
          <b-col cols="6">
            <b-form-group
              label="Cupones"
              label-for="totalPlasticosPesos"
              :label-cols="labelColsImportes"
              horizontal>
              <b-form-input 
                id="totalPlasticosPesos" 
                :value="totalPlasticosPesos | moneda" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Saldo"
              label-for="saldoAnteriorPesos"
              :label-cols="labelColsImportes"
              horizontal>
              <b-form-input 
                id="saldoAnteriorPesos"
                :value="saldoAnteriorPesos | moneda" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <br>

            <b-form-group
              label="Consumos"
              label-for="importeConsumosPesos"
              :label-cols="labelColsImportes"
              description="Consumos + Saldos ($)"
              horizontal>
              <b-form-input 
                id="importeConsumosPesos"
                v-model.trim="$v.importeConsumosPesos.$model" 
                :state="importeConsumosPesosValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="importeConsumosPesosFeedback">
                {{ importeConsumosPesosInvalidoMsj }}  
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label="Gastos"
              label-for="importeGastosPesos"
              :label-cols="labelColsImportes"
              description="Gastos + Impuestos ($)"
              horizontal>
              <b-form-input 
                id="importeGastosPesos"
                v-model.trim="$v.importeGastosPesos.$model" 
                :state="importeGastosPesosValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="importeGastosPesosFeedback">
                {{ importeGastosPesosInvalidoMsj }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group
              label="Cupones"
              label-for="totalPlasticosDolares"
              :label-cols="labelColsImportes"
              horizontal>
              <b-form-input 
                id="totalPlasticosDolares" 
                :value="totalPlasticosDolares | moneda('USD')" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Saldo"
              label-for="saldoAnteriorDolares"
              :label-cols="labelColsImportes"
              horizontal>
              <b-form-input 
                id="saldoAnteriorDolares" 
                :value="saldoAnteriorDolares | moneda('USD')" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <br>

            <b-form-group
              label="Consumos"
              label-for="importeConsumosDolares"
              :label-cols="labelColsImportes"
              description="Consumos + Saldos (USD)"
              horizontal>
              <b-form-input 
                id="importeConsumosDolares"
                v-model.trim="$v.importeConsumosDolares.$model" 
                :state="importeConsumosDolaresValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="importeConsumosDolaresFeedback">
                {{ importeConsumosDolaresInvalidoMsj }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label="Gastos"
              label-for="importeGastosDolares"
              :label-cols="labelColsImportes"
              description="Gastos + Impuestos (USD)"
              horizontal>
              <b-form-input 
                id="importeGastosDolares"
                v-model.trim="$v.importeGastosDolares.$model" 
                :state="importeGastosDolaresValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="importeGastosDolaresFeedback">
                {{ importeGastosDolaresInvalidoMsj }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>

      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Grabar</b-button>
        <b-button size="sm" variant="danger" class="footer-button"
          @click.prevent="cancelar">Cancelar</b-button>
      </div>
    </b-card>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { required, decimal } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';
import moment from 'moment';

const { mapFields } = createHelpers({
  getterType: 'tarjetaResumenCierre/getField',
  mutationType: 'tarjetaResumenCierre/updateField',
});

export default {
  name: 'TarjetaResumenCierre',
  components: {
    appMensaje: Mensaje
  },
  mixins: [
    msjModal, 
  ],
  props: {
    tarjetaResumenId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      noValidar: true,
      importeConsumosPesosValido: null,
      importeConsumosPesosInvalidoMsj: '',
      importeGastosPesosValido: null,
      importeGastosPesosInvalidoMsj: '',
      importeConsumosDolaresValido: null,
      importeConsumosDolaresInvalidoMsj: '',
      importeGastosDolaresValido: null,
      importeGastosDolaresInvalidoMsj: '',

      labelCols: 2,
      labelColsImportes: 4
    }
  },
  computed: {
    ...mapFields([
      'banco',
      'tarjetaMarca',
      'numeroCuenta',
      'fechaCierre',
      'fechaVencimiento',
      'saldoAnteriorPesos',
      'totalPlasticosPesos',
      'importeConsumosPesos',
      'importeGastosPesos',
      'saldoAnteriorDolares',
      'totalPlasticosDolares',
      'importeConsumosDolares',
      'importeGastosDolares',
    ])
  },  
  created() {
    this.showSpinner();
    this.$store.dispatch('tarjetaResumenCierre/inicializar', this.tarjetaResumenId)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'importeConsumosPesos' || validarTodos) {
        if (this.$v.importeConsumosPesos.$error) {
          this.importeConsumosPesosValido = false;
          if (!this.$v.importeConsumosPesos.decimal) {
            this.importeConsumosPesosInvalidoMsj = 'El importe correspondiente a los consumos en pesos debe ser un valor numérico';
          }      
        } else {
          this.importeConsumosPesosValido = null;
          this.importeConsumosPesosInvalidoMsj = '';
        }
      }

      if (campo == 'importeGastosDolares' || validarTodos) {
        if (this.$v.importeGastosPesos.$error) {
          this.importeGastosPesosValido = false;
          if (!this.$v.importeGastosPesos.decimal) {
            this.importeGastosPesosInvalidoMsj = 'El importe correspondiente a los gastos en pesos debe ser un valor numérico';
          }      
        } else {
          this.importeGastosPesosValido = null;
          this.importeGastosPesosInvalidoMsj = '';
        }
      }

      if (campo == 'importeConsumosDolares' || validarTodos) {
        if (this.$v.importeConsumosDolares.$error) {
          this.importeConsumosDolaresValido = false;
          if (!this.$v.importeConsumosDolares.decimal) {
            this.importeConsumosDolaresInvalidoMsj = 'El importe correspondiente a los consumos en dólares debe ser un valor numérico';
          }      
        } else {
          this.importeConsumosDolaresValido = null;
          this.importeConsumosDolaresInvalidoMsj = '';
        }
      }

      if (campo == 'importeGastosDolares' || validarTodos) {
        if (this.$v.importeGastosDolares.$error) {
          this.importeGastosDolaresValido = false;
          if (!this.$v.importeGastosDolares.decimal) {
            this.importeGastosDolaresInvalidoMsj = 'El importe correspondiente a los gastos en dólares debe ser un valor numérico';
          }      
        } else {
          this.importeGastosDolaresValido = null;
          this.importeGastosDolaresInvalidoMsj = '';
        }
      }
    },
    save () {
      let save = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('tarjetaResumenCierre/save')
            .then(() => this.showModalMsj('Los cambios se registraron con éxito', 
              this.close.bind(this, true), this.close.bind(this, true), 'light'))
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner());
        }
      } 
    },
    cancelar() {
      this.close(false);
    },
    close(cierreRegistrado) {
      this.$emit('close', cierreRegistrado);
    },
  },
  validations: {
    importeConsumosPesos: { decimal },
    importeGastosPesos: { decimal },
    importeConsumosDolares: { decimal },
    importeGastosDolares: { decimal }
  },   
}
</script>

<style>
</style>
